import React from 'react';
import PropTypes from 'prop-types';
import TextInputField from './TextInputField';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  password: {
    id: 'Common.password',
    defaultMessage: 'Password',
    description: 'Field title',
  },
});

const Password = ({ 'aria-describedby': ariaDescribedBy }) => {
  const { formatMessage } = useIntl();

  return (
    <TextInputField
      type="password"
      name="password"
      placeholder={formatMessage(messages.password)}
      addEyeIcon
      aria-describedby={ariaDescribedBy}
    />
  );
};

Password.propTypes = { 'aria-describedby': PropTypes.string };

export default Password;
